module.exports = __webpack_public_path__ + "img/Icon PDF - Ícone.4558eecf.png";